import React from 'react';
import classNames from 'classnames';

interface ProgressBarProps {
  value: number;
  max: number;
}

const ProgressBar = ({ value, max }: ProgressBarProps) => {
  const percentage = (value / max) * 100;

  return (
    <div className="w-full bg-gray-200 rounded-full h-2.5">
      <div
        className={classNames('h-2.5 rounded-full', {
          'bg-primary-400': max !== 0
        })}
        style={{ width: `${percentage}%` }}
      />
    </div>
  );
};

export default ProgressBar;
